import React, { useState } from 'react';

import {
    FileInput,
    Container,
    Title,
    Flex,
    Button,
    Divider,
    List,
} from '@mantine/core';

import { API_DOMAIN } from '../../const';
import useLocalStorageList from '../../hooks/useLocalStorageList';

function FileStorageUtility() {
    const { list, handleClearList, handleAddItem } = useLocalStorageList('file-storage-list');

    const [value, setValue] = useState();
    const [isUploading, setIsUploading] = useState(false);

    const handleSetValue = (file) => {
        setValue(file);
    };

    const handleUploadSubmit = async () => {
        if (!value) {
            return;
        }

        const formData = new FormData();
        formData.append('file', value);

        try {
            setIsUploading(true);
            const response = await fetch(`${API_DOMAIN}storage/files/`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    enctype: 'multipart/form-data',
                },
                body: formData,
            });

            if (response.ok) {
                const json = await response.json();

                handleAddItem({
                    url: json.url,
                    size: json.size,
                    originalName: value.name,
                    time: new Date().getTime(),
                });

                setValue();
            }
        } catch (error) {
            // ignore
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <Container p="xs" m={0}>
            <Flex direction="column" gap="xs">
                <Title order={3}>Загрузить файл в хранилище</Title>
                <Flex gap="md">
                    <Container p={0} m={0} miw="20rem">
                        <FileInput
                            name="file"
                            placeholder="Выберите файл для загрузки"
                            value={value}
                            onChange={handleSetValue}
                        />
                    </Container>
                    <Button
                        disabled={!value}
                        loading={isUploading}
                        onClick={handleUploadSubmit}
                    >
                        Загрузить
                    </Button>
                </Flex>
                <Divider my="sm" />
                <Flex gap="md" align="center">
                    <Title order={3}>Мои файлы</Title>
                    <Button size="xs" color="red" variant="outline" onClick={handleClearList}>
                        Очистить список
                    </Button>
                </Flex>
                <List spacing="xs">
                    {list.map((item) => (
                        <List.Item key={item.time}>
                            <Flex direction="column">
                                <Flex gap="xs">
                                    <span>
                                        Дата загрузки:
                                        {' '}
                                        {new Date(item.time).toLocaleString()}
                                    </span>
                                    <Divider orientation="vertical" />
                                    <span>
                                        Оригинальное название:
                                        {' '}
                                        {item.originalName}
                                    </span>
                                    <Divider orientation="vertical" />
                                    <span>
                                        Размер:
                                        {' '}
                                        {item.size}
                                        {' '}
                                        Байт
                                    </span>
                                </Flex>
                                <Flex>
                                    URL:
                                    {' '}
                                    {item.url}
                                </Flex>
                            </Flex>
                        </List.Item>
                    ))}
                </List>
            </Flex>
        </Container>
    );
}

export default FileStorageUtility;
